import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const userBioLinkDetails = createAsyncThunk('userBioLinkDetails', async (data) => {
    const token = localStorage.getItem('token')
    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `urlbased_profilelink`,
            params: {
                user_name: data?.username,
                user_id: token ? localStorage.getItem("id") : '',
            },
            headers: { "Content-Type": "application/json" }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const userBioLinkDetailsSlice = createSlice({
    name: 'userBioLinkDetails',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(userBioLinkDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                state.data = [];
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.data = [];
            }
        });
        builder.addCase(userBioLinkDetails.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default userBioLinkDetailsSlice.reducer; 